import { WorkflowRuntimeStepStatus } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { WORKFLOW_EXECUTION_BASE_URL } from './helpers';

export async function updateStep({
  workflowExecutionId,
  stepId,
  outputData,
  status,
}: {
  workflowExecutionId: string;
  stepId: string;
  outputData?: Record<string, any>;
  status?: WorkflowRuntimeStepStatus;
}) {
  const response = await fetcher(
    `${WORKFLOW_EXECUTION_BASE_URL}/${workflowExecutionId}/step/${stepId}`,
    {
      method: 'POST',
      body: { outputData, status },
    }
  );

  return response;
}
